import { render, staticRenderFns } from "./CreateUserAdmin.vue?vue&type=template&id=2a58b747&"
import script from "./CreateUserAdmin.vue?vue&type=script&lang=js&"
export * from "./CreateUserAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports